<template>
	<div class="login_body">
		<div class="container">
			<div class="log">
			    <div class="logo">
            <img src="../assets/login/logo_01.jpg">
            <h2>
              用户登录
              <img src="../assets/login/login.png" />
            </h2>
          </div>
			    <!--				<h1>SCCMS</h1>-->
          <el-form
          ref="login_form"
          :model="login_form"
          class="login_form"
          :rules="login_rules"
          >
            <el-form-item prop="userName">
              <el-input
              placeholder="请输入工号"
              @blur="userName_focus"
              v-model="login_form.userName">
                <template slot="prefix">
                  <span style="font-size: 18px;">
                    <i class="el-icon-user"></i>
                  </span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="passWord">
              <el-input
              type="password"
              placeholder="请输入密码"
              v-model="login_form.passWord">
                <template slot="prefix">
                  <span style="font-size: 18px;">
                    <i class="el-icon-unlock"></i>
                  </span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="dataWarehouseType">
              <el-select
              ref="dataWarehouse_pc"
              :popper-append-to-body="false"
              v-model="login_form.dataWarehouseType"
              clearable
              style="width: 100%;"
              placeholder="请选择数据仓"
              prefix-icon="el-icon-house"
              >
                <template slot="prefix">
                  <span style="font-size: 18px;">
                    <i class="el-icon-house"></i>
                  </span>
                </template>
                <el-option
                v-for="item in dataWarehouseType_list"
                :key="item.value"
                :label="item.name"
                :value="item.value"
                :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form_other">
              <el-button
              style="width: 100%;"
              type="primary"
              native-type="submit"
              @click.prevent="loginBtn()"
              >登录</el-button>
            </el-form-item>
          </el-form>
			    <!-- <form action="">
			        <p>
			            <i class="user"></i>
			            <input type="text" ref="username" placeholder="请输入工号" name="username" autofocus="autofocus"/>
			        </p>
			        <p>
			            <i class="password"></i>
			            <input type="password" ref="password" name="password" placeholder="请输入密码"/>
			        </p>
              <p>

              </p>
			        <p>
			            <input type="submit" id="submit" name="loginBtn" @click.prevent="loginBtn()" value="登录"/>
			        </p>
          </form> -->
          <div class="login_else">
            <a href="#" @click.prevent="$router.push({path:'/regist_QRcode'})">
                点击注册
                <img src="../assets/login/regist.png" />
            </a>
            <a herf="#" name="loginByWechat" @click="loginByWechat()">
                微信登陆
                <img src="../assets/login/wx_login.png" />
            </a>
          </div>
      </div>
      <div class="login_footer">
      	<a href="https://beian.miit.gov.cn" target="_blank">copyright @2022 沪ICP备09093429号 上海润达医疗科技股份有限公司</a>
      </div>
		</div>
    <!-- 扫码登录弹框 -->
    <el-dialog
    :append-to-body="true"
    :visible.sync="scan_visible"
    title="数据仓选择"
    >
      <el-select
      ref="dataWarehouse_pc_scan"
      style="width: 100%;"
      :popper-append-to-body="false"
      v-model="scan_dataWarehouse"
      placeholder="请选择"
      clearable
      >
        <el-option
        v-for="item in dataWarehouse_data"
        :key="item.value"
        :label="item.name"
        :value="item.value"
        :disabled="item.disabled"
        ></el-option>
      </el-select>
      <el-button
      style="width: 100%;margin-top: 22px;"
      type="primary"
      @click="pc_scan_login()"
      >登录</el-button>
    </el-dialog>
  </div>
</template>

<script>
	export default {
		data(){
			return{
				url:'http://scc.runda-logistics.com/wechat/sccms_service_wechat/wx/redirect/wxde5ff1481e0391e8s/loginByQrCode',
				code:'',
        //所属数据仓下拉框
        dataWarehouseType_list:[],
        // 普通登录表单
        login_form:{
          userName:'',
          passWord:'',
          dataWarehouseType:''
        },
        //普通登录表单正则
        login_rules:{
          userName:[
            {required:true,message:'请输入工号',trigger:'blur'}
          ],
          passWord:[
            {required:true,message:'请输入密码',trigger:'blur'}
          ],
          dataWarehouseType:[
            {required:true,message:'请选择所属数据仓',trigger:'change'}
          ]
        },
        //用户扫码登录相关
        scan_visible:false,
        scan_dataWarehouse:'',
        dataWarehouse_data:[],
        scan_unionId:''
			}
		},
    beforeCreate() {
      document.querySelector('body').setAttribute('style','zoom: 1;')
    },
		created() {
			let that=this
      that.publicAjax.axios_set()
      that.code=that.getUrlParam('code')
      // that.code='0416xUkl2nvIRb4Bo5ml2jM59A26xUkI'
      if(that.code){
        //获取用户数据仓
        that.$axios({
          method:'get',
          url:that.publicAjax.extra_path+'/admin/user/beforeLogin/dataWarehouseFromSelect',
          params:{
            userName:'',
            deviceType:'pc_scan',
            code:that.code,
            unionId:''
          }
        }).then(data=>{
          if(data.data.success==true){
            that.dataWarehouse_data=data.data.data.dataWarehouseTypes
            that.dataWarehouse_data.forEach((item)=>{
              if(item.selected==true){
                that.scan_dataWarehouse=item.value
              }else{
                that.scan_dataWarehouse=that.dataWarehouse_data[0].value
              }
            })
            that.scan_unionId=data.data.data.unionId
            if(that.dataWarehouse_data.length>1){
              that.scan_visible=true
            }else{
              that.scan_visible=false
              //用户扫码登录
              that.pc_scan_login()
            }
          }else{
            that.$message.warning(data.data.message)
          }
        })
      }
    },
		mounted() {

		},
		methods:{
      //获取url后的参数值
      getUrlParam(key) {
      	var href = window.location.href;
      	var url = href.split("?");
      	if(url.length <= 1){
      		return "";
      	}
      	var params = url[1].split("&");

      	for(var i=0; i<params.length; i++){
      		var param = params[i].split("=");
      		if(key === param[0]){
      			return param[1];
      		}
      	}
      },
			//微信扫码登录前置
			loginByWechat(){
				let URIstring = "http://scc.runda-logistics.com"
        let redirectUri = this.urlEncode(URIstring)
				let stringUrl = " https://open.weixin.qq.com/connect/qrconnect?appid=wxb41446a9c238f633&redirect_uri=" + redirectUri + "&response_type=code&scope=snsapi_login&state=#wechat_redirect"
				window.location.href=stringUrl
			},
			urlEncode(str){
				str = (str + '').toString()
				return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+')
			},
      //微信扫码登录
      pc_scan_login(){
        let that=this
        that.$axios({
          method:'post',
          url:that.publicAjax.extra_path+'/admin/user/pcScanLogin/'+that.scan_dataWarehouse,
          data:{
            unionId:that.scan_unionId
          },
          headers:{
            "client": "web", //电脑浏览器:web,手机:mobile
            "content-type":"application/json;charset=UTF-8"
          }
        }).then(data=>{
          if(data.data.success){
            let token=data.data.data.token
            let userName=data.data.data.userName
            let nickName=data.data.data.nickName
            let menu=data.data.data.menu
            let data_ware_house=data.data.data.dataWarehouse
            //更新用户信息
            localStorage.setItem('dataWarehouse',data_ware_house)
            localStorage.setItem('nickName',nickName)
            localStorage.setItem(userName+'token',token)
            localStorage.setItem('userName',userName)
            localStorage.setItem(userName+'menu',JSON.stringify(menu))
            that.$message.success('验证登录通过，正在跳转主页...请稍候')
            setTimeout(function(){
              that.$router.push({
                path:'/warn_index'
              })
            },2000)
          }else{
            if(data.data.message=='用户不存在,请先注册！'){
              that.$message.warning('您的微信号没有注册过SCCMS，请打开润达物流公众号进行注册!')
              setTimeout(function(){
                that.$router.push({
                  path:'/regist_QRcode'
                })
              },2000)
            }else{
              that.$message.warning(data.data.message)
            }
          }
        })
      },
      //用户名失焦事件
      userName_focus(){
        let that=this
        //获取用户所属数据仓
        that.$axios({
          url:that.publicAjax.extra_path+'/admin/user/beforeLogin/dataWarehouseFromSelect',
          method:'get',
          params:{
            userName:that.login_form.userName,
            deviceType:'pc',
            code:'',
            unionId:''
          }
        }).then(data=>{
          if(data.data.success==true){
            that.dataWarehouseType_list=data.data.data
            that.$nextTick(()=>{
              that.dataWarehouseType_list.forEach((item)=>{
                if(item.selected==true){
                  that.login_form.dataWarehouseType=item.value
                }else{
                  that.login_form.dataWarehouseType=that.dataWarehouseType_list[0].value
                }
              })
            })
          }else{
            that.dataWarehouseType_list=[]
            that.login_form.dataWarehouseType=''
          }
        })
      },
			//账号密码登录
			loginBtn(){
        let that=this
        that.$refs.login_form.validate((valid)=>{
          if(valid){
            that.$axios({
            	method:'post',
            	url:that.publicAjax.extra_path+'/admin/user/pcLogin/'+that.login_form.dataWarehouseType,
            	data:{
            		userName:that.login_form.userName.trim(),
            		passWord:that.login_form.passWord.trim()
            	},
              headers:{
                "client": "web", //电脑浏览器:web,手机:mobile
                "content-type":"application/json;charset=UTF-8"
              }
            }).then(data=>{
            	if(data.data.code==0){
            		let token=data.data.data.token
            		let userName=data.data.data.userName
                let nickName=data.data.data.nickName
                let menu=data.data.data.menu
                //更新用户信息
                localStorage.setItem('dataWarehouse',that.$refs.dataWarehouse_pc.selected.label)
                localStorage.setItem('nickName',nickName)
            		localStorage.setItem(userName+'token',token)
            		localStorage.setItem('userName',userName)
                localStorage.setItem(userName+'menu',JSON.stringify(menu))
                that.$message.success('验证登录通过，正在跳转主页...请稍候')
                setTimeout(function(){
                  that.$router.push({
                    path:'/warn_index'
                  })
                },1000)

                // that.layer.msg('验证登录通过，正在跳转主页...请稍候', {
                //     icon: 16,
                //     shade: 0.01,
                //     time: 2000
                // }, function () {
                //   that.$router.push({
                //     path:'/warn_index'
                //   })
                // })
            	}else{
            		let msg=data.data.code+':'+data.data.message
            		that.$message.error("登录失败:" + msg)
            	}
            })
          }else{
            return false
          }
        })
      }
		}
	}
</script>

<style scoped="scoped">
  * {
		/* margin: 0;
		padding: 0; */
		box-sizing: border-box;
	}
	.login_body {
    background-image: url(https://api.dujin.org/bing/1920.php);
		background-size: 100% 100%;
		background-repeat: no-repeat;
    height: 100%;
	}
  .container{
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }
  .log{
  	border-radius: 10px;
  	margin: 0px auto;
    width: 450px;
  	padding: 30px 35px 15px;
  	background: #fff;
  	border: 1px solid #eaeaea;
  	text-align: left;
  	box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  }
  .logo {
  	margin-bottom: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo>img{
    width: 200px;
    margin-right: 10px;
  }
  .logo h2{
    font-weight: 700;
  }
  .logo h2 img{
    width: 30px;
  }
	a {
		text-decoration: none;
	}

	input {
		outline: none;
	}
  .log input {
		width: 375px;
		padding: 14px 20px 14px 40px;
		margin-bottom: 20px;
		border: 1px solid #E5E5E5;
		border-radius: 5px;
		color: #BBB8C1;
	}

	.log input:focus {
		border: 1px solid #cccccc;
	}

	.log p {
		position: relative;
	}

	/* .user {
		display: inline-block;
		width: 20px;
		height: 24px;
		background: url(../assets/login/username.png);
		position: absolute;
		top: 10px;
		left: 10px;
	}

	.password {
		display: inline-block;
		width: 19px;
		height: 25px;
		background: url(../assets/login/password.png);
		position: absolute;
		top: 10px;
		left: 10px;
	} */
	.login_else{
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .login_else a{
    cursor: pointer;
  }
  .login_else a img{
    width: 30px;
    margin-left: 5px;
  }
  .login_footer{
  	position: fixed;
  	bottom: 20px;
  }
  .login_footer a{
  	color: #FFFFFF;
  	font-weight: 700;
  }
  .el-input__icon{
    font-size: 100px;
  }
  /*响应式*/

	@media (max-width:600px) {
		.container{
			flex-wrap:wrap;
		}
		.log input{
			width: 320px;
		}
		.reg{
			width: 420px;
			height: 300px;
			margin-top: 20px;
			padding: 50px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/login.vue